"use client";

import type { FC, Ref } from "react";
import { ContentMenuProvider } from "@huub-web/ui";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface ContentMenuProviderTemplateProps {
  templates: TemplateCollection;
}

/**
 * @deprecated
 */
export const ContentMenuProviderTemplate: FC<
  ContentMenuProviderTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, ref }) => (
  <div ref={ref} style={{ display: "contents" }}>
    <ContentMenuProvider>
      <TemplatesParser templates={templates} level={0} />
    </ContentMenuProvider>
  </div>
);
